module.exports = __webpack_public_path__ + "img/barraga_act.b8af36dc.png";